/** Strip whitespace and any quote wrapper the model may add around the edit. */
export const normalizeInlineEditResult = (raw: string): string => {
  let text = raw.trim();
  const pairs: Array<[string, string]> = [
    ['"', '"'],
    ['“', '”'],
  ];
  for (const [open, close] of pairs) {
    if (text.startsWith(open) && text.endsWith(close) && text.length >= 2) {
      text = text.slice(open.length, -close.length).trim();
    }
  }
  return text;
};

const escapeHtml = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/**
 * Plain text → insertable HTML. Single paragraphs stay inline (no `<p>`
 * wrapper) so short rewrites don't split the surrounding block; multi-line
 * results become paragraphs with hard breaks.
 */
export const toInsertableHtml = (text: string): string => {
  const paragraphs = text
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.split('\n').map(escapeHtml).join('<br>'));
  if (paragraphs.length <= 1) return paragraphs[0] ?? '';
  return paragraphs.map((paragraph) => `<p>${paragraph}</p>`).join('');
};

/**
 * Like `toInsertableHtml` but always block-level — used by "Insert below"
 * so the new text lands on its own line(s) beneath the original.
 */
export const toInsertableBlockHtml = (text: string): string => {
  const html = toInsertableHtml(text);
  return html.startsWith('<p>') ? html : `<p>${html}</p>`;
};
